import { mix } from "@chorda/core";
export const Paragraph = (props) => {
    return mix({
        tag: 'p'
    }, props);
};
